import React from 'react'

const Pricing = () => {
  return (
    <div>
      
    </div>
  )
}

export default Pricing
